module.exports = __webpack_public_path__ + "img/icon-music-2.445ad559.svg";